<template>
  <component :is="this.getComponent" :data="this.data" :index="this.index" :useCustomPadding="this.useCustomActionPadding" />
</template>

<script lang="ts">

import { ReplyOptionsData, ReplyOptionType } from "@/TickApi";
import { Component, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import ChoiceOption from "./ChoiceOption.ce.vue";
import SummarizedItemOption from "./SummarizedItemOption.ce.vue";


@Component({
  emits: [],
  components: { ChoiceOption, SummarizedItemOption },
})
export default class BaseReplyOption extends Vue {
  @Prop() private data!: ReplyOptionsData;
  @Prop() private index!: number;
  @Prop() private useCustomActionPadding!: boolean;

  private get getComponent(): string {
    switch (this.data.type) {
      case ReplyOptionType.ChoiceOption: return "ChoiceOption";
      case ReplyOptionType.SummarizedItemOption: return "SummarizedItemOption";
      default: return "div";
    }
  }
}
</script>